<span class="chip__text">
  <span class="chip__label">{{ label() }}@if (value()) {<span aria-hidden="true">:</span>}</span>
  @if (value()) {
    <span class="chip__value">{{ value() }}</span>
  }
</span>
<button type="button" class="chip__remove" [attr.aria-label]="removeLabel()" (click)="remove.emit()">
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
  </svg>
</button>
